module.exports = __webpack_public_path__ + "static/media/tuagom-sit.f04b1882.png";